import Style1 from './Style1.vue'
import Style2 from './Style2.vue'
import Style3 from './Style3.vue'

export const BlogItems = {
  Style1,
  Style2,
  Style3,
}
